import { useQuery } from '@tanstack/react-query'
import { learnerGamesApi, type GameWithStatus } from '@/api/learnerGames'

export const learnerGamesQueryKey = ['learner', 'me', 'games'] as const

export function useLearnerGames() {
  return useQuery({
    queryKey: learnerGamesQueryKey,
    queryFn: async (): Promise<GameWithStatus[]> => {
      const res = await learnerGamesApi.list()
      return res.data.data.items
    },
    staleTime: 60 * 1000,
    refetchOnWindowFocus: true,
  })
}
